export const isFormikValid = ({ isValid, touched }: { isValid?: boolean; touched?: any }) =>
  isValid && Object.keys(touched ?? {}).length > 0;
